module.exports = __webpack_public_path__ + "assets/icons/ic_invoice_24px.svg";